export default {
  signals: { partial: 'Часть связанных сигналов — в функциях другого тарифа; здесь показана связь с доступными.' },
};
